import React, { useEffect, useState, useContext} from 'react'
import Typography from '@mui/material/Typography';
import './WorkPreferencesScheduleInterviewUI.css'
import { Button, CardActionArea, CardActions } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from "@mui/material/TextField";
import { Container } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from './UserContext';



const WorkPreferencesScheduleInterviewUI = (props) => {

//useState

    const [voiceProcess,setVoiceProcess] = useState(true)
    const [nonVoiceProcess,setNonVoiceProcess] = useState(false)
    const [workFromHome,setWorkFromHome] = useState(false)
    const [workFromOffice,setWorkFromOffice] = useState(true)
    const [partTime,setPartTime] = useState(false)
    const [fullTime,setFullTime] = useState(true)
    const [temporary,setTemporary] = useState(true)
    const [nightShift,setNightShift] = useState(true)
    const [dayShift,setDayShift] = useState(true)
    const [companyTransportDay,setCompanyTransportDay] = useState(true)
    const [companyTransportNight,setCompanyTransportNight] = useState(true)
    const [ownTransport,setOwnTransport] = useState(true)
    const [hightlight,setHighlight] = useState({})

  //UseEffect     
 useEffect(()=>{
      let preferences = props.preferences;

      if(props.highlight)
    { 
      
       setHighlight(JSON.parse(props.highlight.candidatePreference))
       
    }

    if(preferences){
            setVoiceProcess(preferences.voiceProcess)
            setNonVoiceProcess(preferences.nonVoiceProcess)
            setWorkFromHome(preferences.workFromHome)
            setWorkFromOffice(preferences.workFromOffice)
            setPartTime(preferences.partTime)
            setFullTime(preferences.fullTime)
            setNightShift(preferences.nightShift)
            setDayShift(preferences.dayShift)
            setCompanyTransportDay(preferences.companyTransportDay)
            setCompanyTransportNight(preferences.companyTransportNight)
            setOwnTransport(preferences.ownTransport)
    }
   
   },[props.preferences,props.highlight])

//Functions

 
  return (
    <div>
    <div className='VoicePreference'>
    <input disabled={props.type==="View"}  type="checkbox" id="VoicePreference" name="chkVoice" checked={voiceProcess} onChange={()=>props.setPreference("voiceProcess",!voiceProcess)}/>
    </div>
    <label id='Voice_candidate_lbl' for="chkVoice" style={{color:voiceProcess?"red":"black",backgroundColor:(hightlight.voiceProcess===true)?"yellow":"transparent",borderRadius:"12px"}}> Voice </label>

    <div className='Non_VoicePreference'>
<input disabled={props.type==="View"} type="checkbox" id="Non_VoicePreference" name="chkNonvoice" checked={nonVoiceProcess} onChange={()=>props.setPreference("nonVoiceProcess",!nonVoiceProcess)}/>
</div>
 <label id='Non-Voice_lbl' for="chkNonvoice" style={{color:nonVoiceProcess?"red":"black",backgroundColor:(hightlight.nonVoiceProcess===true)?"yellow":"transparent",borderRadius:"12px"}}> Non-Voice </label>

 <div className='Semi-VoicePreference'>
    <input disabled={props.type==="View"} type="checkbox" id="Semi-VoicePreference" name="chkSemiVoice" checked={nonVoiceProcess===true && voiceProcess===true} onChange={(e)=>{
        
        if(e.target.checked===true){
          props.setPreference("voiceProcess",true)
          props.setPreference("nonVoiceProcess",true)
        }
        
        }}/>
	</div>
    <label id='Semi-Voice_candidate_Lbl' for="chkSemiVoice" style={{color:(nonVoiceProcess===true && voiceProcess===true?"red":"black"),backgroundColor:(hightlight.nonVoiceProcess===true) && (hightlight.voiceProcess===true) ?"yellow":"transparent",borderRadius:"12px"}}> Semi Voice </label>


  <div id="Candidate_Employment_Type">
		<span>Employment Type</span>
	</div>

  <div className='FullTime_Preference'>
        <input disabled={props.type==="View"} type="checkbox" id="FullTime_Preference" name="chkFullTime" checked={fullTime} onChange={()=> props.setPreference("fullTime",!fullTime)}/>
    </div>
    <label id='Full_Time_Interview_Lbl' for="chkFullTime" style={{color:fullTime?"red":"black",backgroundColor:(hightlight.fullTime===true)?"yellow":"transparent",borderRadius:"12px"}}> Full Time </label>

    <div className='Part_Time_Preference'>
    <input disabled={props.type==="View"} type="checkbox" id="Part_Time_Preference" name="chkPartTime" checked={partTime} onChange={()=>props.setPreference("partTime",!partTime)}/>     
    </div>
    <label id='Part_Time_Candidate_lbl' for="chkPartTime" style={{color:partTime?"red":"black",backgroundColor:(hightlight.partTime===true)?"yellow":"transparent",borderRadius:"12px"}}> Part Time </label>

    <div className='Temporary_Preference'>
    <input disabled={props.type==="View"} type="checkbox" id="chkTemporary" name="chkPartTime" checked={temporary} onChange={()=>props.setPreference("temporary",!temporary)}/>     
    </div>
    <label id='Temporary_Preference_Lbl' for="chkPartTime" style={{color:temporary?"red":"black",backgroundColor:(hightlight.temporary===true)?"yellow":"transparent",borderRadius:"12px"}}> Temporary</label>

  <div id="Work_Mode_Title">
		<span>Work Mode</span>
	</div>
  
  <div className='Office_Preferences'>
    <input disabled={props.type==="View"} type="checkbox" id="Office_Preferences" name="chkWorkfromoffcice" checked={workFromOffice} onChange={()=> props.setPreference("workFromOffice",!workFromOffice)}/>
    </div>
    <label id='Office_Preference_lbl' for="chkWorkfromoffcice" style={{color:workFromOffice?"red":"black",backgroundColor:(hightlight.workFromOffice===true)?"yellow":"transparent",borderRadius:"12px"}}>Office</label>
	
  
    <div className='Home_Preferences'>
        <input disabled={props.type==="View"} type="checkbox" id="Home_Preferences" name="chkWorkfromhome" checked={workFromHome} onChange={()=> props.setPreference("workFromHome",!workFromHome)}/>
    </div>
        <label id='Home_Preferences_lbl' for="chkWorkfromhome" style={{color:workFromHome?"red":"black",backgroundColor:(hightlight.workFromHome===true)?"yellow":"transparent",borderRadius:"12px"}}>Home</label>
  

        <div className='Hybrid_Preference'>
    <input disabled={props.type==="View"} type="checkbox" id="Hybrid_Preference" name="chkHybrid" checked={workFromOffice===true && workFromHome===true} onChange={(e)=>{
         if(e.target.checked===true){
          props.setPreference("workFromHome",true)
          props.setPreference("workFromOffice",true)
          setWorkFromOffice(true)
          setWorkFromHome(true)
         }
         
        }}/>
    </div>

        <label id='Hybrid_Preference_lbl' for="chkHybrid" style={{color:workFromOffice===true && workFromHome===true?"red":"black",backgroundColor:(hightlight.workFromOffice===true)&& (hightlight.workFromHome===true)?"yellow":"transparent",borderRadius:"12px"}}>Hybrid</label>

  <div id="Shifts_Preference">
		<span>Shifts</span>
	</div>

  <div className='Day_Preference'>
    <input disabled={props.type==="View"} type="checkbox" id="Day_Preference" name="chkDayShift" checked={dayShift} onChange={()=> props.setPreference("dayShift",!dayShift)}/>
    </div>
    <label id='Day_Preference_lbl' for="chkDayShift" style={{color:dayShift?"red":"black",backgroundColor:(hightlight.dayShift===true)?"yellow":"transparent",borderRadius:"12px"}}>Day</label>

    <div className='Night_preference_'>
    <input disabled={props.type==="View"} type="checkbox" id="Night_preference_" name="chkNightShift" checked={nightShift} onChange={()=> props.setPreference("nightShift",!nightShift)}/>
    </div>
    <label id='Night_preference_lbl_' for="chkNightShift" style={{color:nightShift?"red":"black",backgroundColor:(hightlight.nightShift===true)?"yellow":"transparent",borderRadius:"12px"}}>Night</label>

    <div className='Rotational_Preference_'>
    <input disabled={props.type==="View"} type="checkbox" id="Rotational_Preference_" name="chkRotaionalShift" checked={nightShift===true && dayShift===true} onChange={(e)=>{
         if(e.target.checked===true){
          props.setPreference("nightShift",true)
          props.setPreference("dayShift",true)
         }
          }}/>
    </div>
        <label id='Rotational_Preference_lbl' for="chkRotationalShift" style={{color:nightShift===true && dayShift===true?"red":"black",backgroundColor:(hightlight.nightShift===true)  && (hightlight.dayShift===true)?"yellow":"transparent",borderRadius:"12px"}}>Rotational</label>


  <div id="Candiates_Transportation">
		<span>Transportation</span>
	</div>

  <div className='Own_Transporation_Preference'>
    <input disabled={props.type==="View"} type="checkbox" id="Own_Transporation_Preference" name="chkOwnTransport" checked={ownTransport} onChange={()=> props.setPreference("ownTransport",!ownTransport)}/>
    </div>
    <label id='Own_Transporation_Preference_lbl' for="chkOwnTransport" style={{color:ownTransport?"red":"black",backgroundColor:(hightlight.ownTransport===true)?"yellow":"transparent",borderRadius:"12px"}}>Own</label>


    <div className='Company_Day_Preference_'>
    <input disabled={props.type==="View"} type="checkbox" id="Company_Day_Preference_" name="chkCompanyTransportDay" checked={companyTransportDay} onChange={()=>props.setPreference("companyTransportDay",!companyTransportDay)}/>
    </div>
    <label id='Company_Day_Preference_lbl' for="chkCompanyTransportDay" style={{color:companyTransportDay?"red":"black",backgroundColor:(hightlight.companyTransportDay===true)?"yellow":"transparent",borderRadius:"12px"}}> Company Day</label>       

    <div className='Company_Night_Preference_'>
    <input disabled={props.type==="View"} type="checkbox" id="Company_Night_Preference_" name="chkCompanyTransportNight" checked={companyTransportNight} onChange={()=>props.setPreference("companyTransportNight",!companyTransportNight)}/>
    </div>
    
    <label id='Company_Night_Preference_lbl_' for="chkCompanyTransportNight" style={{color:companyTransportNight?"red":"black",backgroundColor:(hightlight.companyTransportNight===true)?"yellow":"transparent",borderRadius:"12px"}}> Company Night</label>       

     </div>
  )
}

export default WorkPreferencesScheduleInterviewUI
